<template>
  <div
    id="settings"
    class="wrapper"
    style="padding-bottom: 2rem; background-color: white;"
  >
    <page-heading title="Security Settings" border>
      <template #content> </template>
    </page-heading>
    <div class="settings-template">
      <div class="two-factor-auth">
        <h2>Two-Factor Authentication</h2>
        <p>
          Enhance your organization's security by enabling two-factor
          authentication.
        </p>
        <div class="toggle-container">
          <label class="switch" style="position: relative; z-index: 10;">
            <div v-if="loading && !enable2FA" class="spinner-start "></div>
            <div v-if="loading && enable2FA" class="spinner-end "></div>
            <input
              type="checkbox"
              :disabled="loading"
              v-model="enable2FA"
              id="2fa-toggle"
              @click="toggle2FA"
            />
            <span class="slider round"></span>
          </label>
          <span id="toggle-status">{{
            enable2FA && loading
              ? "Enabling..."
              : !enable2FA && loading
              ? "Disabling..."
              : enable2FA
              ? "Enabled"
              : "Disabled"
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/axios";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      enable2FA: false,
      loading: false
    };
  },
  methods: {
    ...mapActions("bussiness", ["settingsList"]),
    async toggle2FA() {
      try {
        this.loading = true;
        const payload = {
          is2faEnabled: !this.enable2FA,
          tenantId: this.settings[0].tenant.id
        };
        const res = await api.post(
          "/tenant/security-setting?type=2fa",
          payload
        );
        if (res.status == 201) {
          this.$toasted
            .success("2FA Status changed successfully")
            .goAway("3000");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    ...mapGetters({
      settings: "bussiness/settings"
    })
  },
  async mounted() {
    await this.settingsList();
    this.enable2FA = this.settings[0].tenant.is2faEnabled;
  }
};
</script>
<style scoped>
/* Custom CSS for Two-Factor Authentication Module */
/* Override inline background-color: white on wrapper */
.wrapper {
  background: var(--canvas) !important;
}

.settings-template {
  margin-bottom: 2rem;
}

.two-factor-auth {
  padding: 28px 32px;
  background: var(--surface-2);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  max-width: 500px;
  margin: 4rem auto;
  text-align: center;
}

.two-factor-auth h2 {
  font-size: var(--fs-h2);
  font-weight: 600;
  margin-bottom: 10px;
  color: var(--ink-900);
  letter-spacing: var(--tracking-tight);
}

.two-factor-auth p {
  font-size: var(--fs-body);
  color: var(--muted);
  margin-bottom: 20px;
  line-height: 1.5;
}

.toggle-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.switch {
  position: relative;
  display: inline-block;
  width: 70px;
  height: 34px;
  margin-right: 10px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--line-strong);
  transition: 0.4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  border-radius: 50%;
  left: 9px;
  bottom: 4px;
  background-color: var(--surface);
  transition: 0.4s;
}

input:checked + .slider {
  background-color: var(--success);
}

input:checked + .slider:before {
  transform: translateX(26px);
}

#toggle-status {
  font-size: var(--fs-body);
  font-weight: 500;
  color: var(--text);
}

.spinner-start {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: var(--accent-600);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
  margin-left: 10px;
  position: absolute;
  left: 30px;
  margin-top: 3px;
  z-index: 1000;
}
.spinner-end {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: var(--accent-600);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
  margin-right: 9px;
  position: absolute;
  right: 30px;
  margin-top: 3px;
  z-index: 1000;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
